export default /*@ngInject*/ function ($scope, helperService) {
    $scope.helperService = helperService;
}
